import { useSearchParams } from 'react-router-dom';

export const useUpdateQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateQueryParams = (newParams: Record<string, any>) => {
    const updatedParams = new URLSearchParams(searchParams);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        updatedParams.delete(key);
      } else {
        updatedParams.set(key, JSON.stringify(value));
      }
    });

    setSearchParams(updatedParams);
  };

  return updateQueryParams;
};
